import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  DisplayableInfo,
  RequirementField
} from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';
import { UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'ba-text',
  templateUrl: 'text-attribute.component.html',
  standalone: false
})
export class TextAttributeComponent implements OnInit {

  @Input() field: RequirementField;
  @Input() form: UntypedFormGroup;
  @Input() displayableInfo: DisplayableInfo;
  @Input() disabled: boolean;

  taxIdMask = '00-0000000';
  maskExpression: string;

  get control() {
    return this.form.controls[this.field.alias];
  }

  get isEmailValue() {
    return [ 'contact.email', 'user.email' ].includes( this.field.alias );
  }

  ngOnInit() {
    if ( this.isEmailValue ) {
      this.control.setValidators( Validators.email );
    }

    this.maskExpression = this.field.alias === 'federalstate_tax_id'
                          ? this.taxIdMask
                          : '';
  }
}
